import * as React from 'react';
import { useEffect, useRef } from 'react';
import { insertStringScript, currencyFormatter,removeErrorOnFocus } from "../../../common/util";
import { Field } from 'redux-form';
import FormDecimal from '../../FormComponents/formDecimal';
import InlineEditableField from '../../InlineEditableField';

const normalizeCurrency = (value, previousValue) => {
    value = value.replace(/,/g, '');
    if (isNaN(value)) {
        return previousValue
    }
    else {
        return currencyFormatter(value);
    }
};

const runPreScript = (id, preScript) => {
    insertStringScript(id, preScript);
};

const runPostScript = (id, postScript) => {
    insertStringScript(id, postScript);
};

const Decimal = (props) => {
    const isMounted = useRef(false);
    const prevDataRef = useRef();

    const renderOnCard = () => {
        let { data, showLabel = false } = props;
        if (Array.isArray(data))
            data = data[0];
        const displayValue = data.Value ? currencyFormatter(data.Value) : '-';
        return (showLabel) ?
                (<li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label>: <span>{displayValue}</span></li>)
            :
            (<li data-test={data.Value}>{displayValue}</li>)
    };

    const renderOnGrid = () => {
        return (
            <div></div>
        )
    };

    const renderOnDetail = () => {
        let { renderType, data, showLabel = false } = props;
        if (Array.isArray(data))
            data = data[0];
        const displayValue = data.Value ? currencyFormatter(data.Value) : '-';
        if (renderType.toLowerCase() === 'activity') {
            if(showLabel){
          return  (<li data-test={data.Label}><label>{data.Label}</label>
               { <InlineEditableField
                type="decimal"
                data={data}
                fieldValue={displayValue}
                canEdit={props.canEditActivity}
                isCompositeField={false}
                removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                updateField={(data) => props.updateActivityField(data)} />}
            </li>)
            }
            else{
              return (<li data-test={data.Value}>{displayValue}</li>);
            }
        } else if (renderType.toLowerCase() === 'workkard') {
            if (showLabel) {
                return (<li data-test={data.Label}>
                <label data-field-label={props.isShowDetailOnPopUp ? data.FieldKey+"label_block" : data.FieldKey}>{data.Label} </label>
                    {(props.dragndrop || !props.isShowDetailOnPopUp) ?
                        (<span>{displayValue}</span>)
                        : <InlineEditableField
                            type="decimal"
                            data={data}
                            canEdit={props.canEditWorkkard}
                            isCompositeField={false}
                            fieldValue={displayValue}
                            removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                            updateField={(data) => props.updateWorkkardFieldInfo(data)} />

                    }
                    </li>);

            } else {
                return displayValue;
            }
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{displayValue}</React.Fragment>)
                :
                displayValue
        }
    };

    const renderOnCreate = () => {
        let { renderType, data, showLabel = false } = props;
        if (renderType.toLowerCase() === 'note') {
            return (showLabel) ?
                (<div data-field-key={data.FieldKey}>
                    <label required-field-Key={data.FieldKey}>{data.Label}{data.IsMandatory ? <span className="red">*</span> : ""} </label>
                    <div className="FieldBlock string">
                        <input type="text" id={data.FieldKey} name={data.FieldKey} placeholder={data.Label} defaultValue={data.Value} onFocus={(e) => removeErrorOnFocus(e)} onKeyUp={(e) => props.onFieldValueChange(e.target)} />
                        <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                    </div>
                </div>)
                :
                (<div>{data.Value}</div>)
        }
        else {
            return (
                <Field
                    name={data[0].Name}
                    component={FormDecimal}
                    labeldivclass="wth-3"
                    label={data[0].FieldGroup}
                    type="text"
                    isRequired={data[0].IsRequired}
                    maxLength={props.data[0].MaxLength != 0 && props.data[0].MaxLength}
                    normalize={normalizeCurrency}
                    isDisabled={data[0].IsNonEditable}
                    placeholder={data[0].Label}
                    onKeyUp={(e) => props.setGlobalSettlement(e)}
                />
            )
        }
    };

    useEffect(() => {
        const data = Array.isArray(props.data) ? props.data[0] : props.data;
        if (data?.preInitScript) {
            runPreScript(`preInitScript-${data.FieldKey}`,data.preInitScript);
        }
        // if (preSaveScript) {
        //     this.runPostScript(`preSaveScript-${data.FieldKey}`,preSaveScript);
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const newData = Array.isArray(props.data) ? props.data[0] : props.data;
        if (!isMounted.current) {
            isMounted.current = true;
            prevDataRef.current = newData;
            return;
        }

        const oldData = prevDataRef.current;
        prevDataRef.current = newData;
        if(oldData && oldData.Id!=newData.Id && props.renderType.toLowerCase() === 'note'){
            const oldPreInitScripts=document.querySelector(`script[id='preInitScript-${oldData.FieldKey}']`);
            const oldPreSaveScripts=document.querySelector(`script[id='preSaveScript-${oldData.FieldKey}']`);
            const newPreInitScript=newData.preInitScript;
            const newPreSaveScript=newData.PreSaveScript;
            //$('#'+newData.FieldKey).val('');
            if(oldPreInitScripts){
                oldPreInitScripts.parentNode.removeChild(oldPreInitScripts);
            }
            if(oldPreSaveScripts){
                oldPreSaveScripts.parentNode.removeChild(oldPreSaveScripts);
            }
            if (newPreInitScript) {
                runPreScript(`preInitScript-${newData.FieldKey}`,newPreInitScript);
            }
            if (newPreSaveScript) {
                runPostScript(`preSaveScript-${newData.FieldKey}`,newPreSaveScript);
          }
        }
    });

    switch (props.renderLocation.toLowerCase()) {
        case "card":
            return renderOnCard();
        case "grid":
            return renderOnGrid();
        case "detail":
            return renderOnDetail();
        case "create":
            return renderOnCreate();
    }
};

export default Decimal;